import { Dispatch, SetStateAction, useContext } from 'react';
import ProductVariantsContext from './ProductVariantsContext';
import IProductVariantList from '../model/IProductVariantList';

export default function useProductVariants(): {
  variants: IProductVariantList;
  setVariants: Dispatch<SetStateAction<IProductVariantList>>;
} {
  const { variants, setVariants } = useContext(ProductVariantsContext);

  return { variants, setVariants };
}
